import React from 'react';
import { MailIcon, PhoneIcon, ReplyIcon } from 'lucide-react';
import { loanOfficer } from '../../data/quote';
export function LoanOfficerSignature() {
  return <section aria-label="Your loan officer" className="rounded-[28px] bg-navy p-6 text-white sm:p-7" data-id="element-78" data-mp="y6xw94ncaoif">
      <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between" data-id="element-79" data-mp="jedwmdzeez5q">
        <div className="flex items-start gap-4" data-id="element-80" data-mp="ocyui6r6h6r0">
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-flame text-lg font-black text-navy" aria-hidden="true" data-id="element-81" data-mp="1c5xik5ndqrbf">
            {loanOfficer.initials}
          </span>
          <div className="min-w-0" data-id="element-82" data-mp="136agriqqnjhu">
            <p className="text-lg font-black leading-tight" data-id="element-83" data-mp="1759tvqmmimkd">{loanOfficer.name}</p>
            <p className="text-sm font-semibold text-white/75" data-id="element-84" data-mp="3nugc7wahoe4j">
              {loanOfficer.title} · {loanOfficer.company}
            </p>
            <p className="mt-2 inline-flex rounded-full bg-white/10 px-2.5 py-0.5 text-xs font-extrabold text-white/90" data-id="element-85" data-mp="3rx38c9e70l7j">
              {loanOfficer.nmls}
            </p>
            <ul className="mt-3 space-y-1.5 text-sm font-semibold" data-id="element-86" data-mp="1nbhctxxrw3n4">
              <li data-id="element-87" data-mp="1ndc1nnc60fwh">
                <a href={loanOfficer.phoneHref} className="inline-flex items-center gap-2 text-white/85 underline-offset-4 hover:text-white hover:underline" data-id="element-88" data-mp="21b0naxe23r2l">
                  <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-89" data-mp="2b8ww3ijiu9xj" />
                  {loanOfficer.phone}
                </a>
              </li>
              <li data-id="element-90" data-mp="269k8uwoqn0uf">
                <a href={`mailto:${loanOfficer.email}`} className="inline-flex items-center gap-2 break-all text-white/85 underline-offset-4 hover:text-white hover:underline" data-id="element-91" data-mp="267zcr2mrz9ug">
                  <MailIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-92" data-mp="2tzejr8phyfc1" />
                  {loanOfficer.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <a href={`mailto:${loanOfficer.email}?subject=Ready%20to%20get%20pre-approved`} className="inline-flex h-14 shrink-0 items-center justify-center gap-2 self-start whitespace-nowrap rounded-full bg-flame px-7 text-lg font-extrabold text-white shadow-bubble duration-150 ease-out hover:bg-[#e83500] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-flame/40 motion-safe:transition-[transform,background-color] motion-safe:hover:-translate-y-0.5 motion-safe:active:translate-y-0 md:self-center" data-id="element-93" data-mp="1mnf8gqhxzxd9">
          <ReplyIcon className="h-5 w-5" aria-hidden="true" data-id="element-94" data-mp="2ab6hnl86ruab" />
          Reply to get pre-approved
        </a>
      </div>
    </section>;
}